import React from "react";
import styled from "styled-components";
import {
  findInputError,
  isFormInvalid,
  StyledTextField,
  FieldTitleTextStyle,
} from "common/components";
import { useFormContext } from "react-hook-form";
import { AnimatePresence, motion } from "framer-motion";

export const Input = ({
  name,
  $isRequired,
  title,
  type,
  id,
  placeholder,
  validation,
  multiline,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputErrors = findInputError(errors, name);
  const isInvalid = isFormInvalid(inputErrors);
  const handleFocus = (event) => {
    event.target.removeAttribute("readOnly"); // 바로 readOnly 속성을 제거
  };

  return (
    <CustomInputLayout>
      {title && (
        <CustomInputTitle>
          <FieldTitleTextStyle htmlFor={id}>
            {title}
            {$isRequired && <span style={{ color: "var(--Red)" }}>*</span>}
          </FieldTitleTextStyle>
          <AnimatePresence mode="wait" initial={false}>
            {isInvalid && (
              <motion.p key={inputErrors.error.message} {...framer_error}>
                {inputErrors.error.message}
              </motion.p>
            )}
          </AnimatePresence>
        </CustomInputTitle>
      )}

      {multiline ? (
        <textarea
          id={id}
          type={type}
          placeholder={placeholder}
          {...register(name, validation)}></textarea>
      ) : (
        <StyledTextField
          autoComplete="off"
          readOnly
          onFocus={handleFocus}
          id={id}
          type={type}
          placeholder={placeholder}
          $error={isInvalid}
          {...register(name, validation)}
        />
      )}
    </CustomInputLayout>
  );
};

const framer_error = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 10 },
  transition: { duration: 0.2 },
};

const CustomInputLayout = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  margin-top: 1rem;
`;

const CustomInputTitle = styled.div`
  display: flex;
  height: 2.5rem;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
